import React from "react";

//import "./index.css";

import ExceptionCategoryTableContainer from "./ExceptionCategoryContainer";
import { MastersContextProvider } from "../../../../contexts/masters.context";

function ExceptionCategory(props) {
  return (
    <MastersContextProvider>
      <div className="deco-container">
        <ExceptionCategoryTableContainer />
      </div>
    </MastersContextProvider>
  );
}

export default ExceptionCategory;
